module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-tabs product-list"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "total"
  }, [_vm._v("\n        " + _vm._s(_vm.tableData.length) + "种产品" + _vm._s(_vm.totalProducts) + "件\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "highlight-current-row": ""
    }
  }, _vm._l((_vm.explains), function(h, index) {
    return _c('el-table-column', {
      key: h.attr,
      attrs: {
        "label": h.attrName,
        "prop": h.attr,
        "show-overflow-tooltip": "",
        "min-width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(h.attr === 'warehouse') ? [_c('span', [_vm._v(_vm._s(scope.row.result[index].attrValue.value))])] : (h.attr === 'productCost' && scope.row.result[index].hideCost) ? [_c('span', [_vm._v("*****")])] : (typeof scope.row.result[index].attrValue === 'number') ? [_c('span', [_vm._v(_vm._s(scope.row.result[index].attrValue))])] : ([5, 6, 8, 10].indexOf(h.fieldType) === -1) ? [_c('span', [_vm._v(_vm._s(scope.row.result[index].attrValue || '--'))])] : _vm._e()]
        }
      }])
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "table-foot"
  }, [_c('span', {
    staticClass: "item"
  }, [_vm._v("出库数量总计：" + _vm._s(_vm.others.outNumTotal) + ";")]), _vm._v(" "), (_vm.hideTotalCost) ? _c('span', {
    staticClass: "item"
  }, [_vm._v("出库成本总计：\n          "), (_vm.others.hideCost) ? _c('span', [_vm._v("*****")]) : _c('span', [_vm._v(_vm._s(_vm.others.outProductCostTotal) + ";")])]) : _vm._e(), _vm._v(" "), (_vm.others.priceTotal || _vm.others.priceTotal === 0) ? _c('span', {
    staticClass: "item"
  }, [_vm._v("售价总计：" + _vm._s(_vm.others.priceTotal))]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-346a4d1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/outstock/product-list.vue
// module id = 1247
// module chunks = 82